/*
 * @author: 16071018
 * @date: 2017/07/06
 */

import Vue from 'vue'
import CONF from '@/app.conf.json'
import {Util} from '../commons/util'

// Promise 垫片
require('core-js/fn/promise');


let Service = {

    /**
     * Promise请求基础方法
     * @params {String} url 请求的url
     * @params {Object} params 请求的参数
     * @return Promise
     * */
    reqPromise(url, params) {

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                params: params
            }).then(data => {
                if (data.body.code === '0') {

                    resolve(data.body.data);
                } else if (data.body.code === '0001') {
                    reject(new Error(`${url}接口参数错误`));
                } else if(data.body.code === '1'){
                    reject( console.log('没有数据。'));
                } else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data));
            });
        });
    },

    /**
     * 根据门店code，查询门店信息
     * @params {String} storeCode 门店Code
     * @return Promise
     * */
    queryStoreByCode(storeCode) {

        let url = CONF.API.storeInfo;

        url = url
            .replace('{{storeCode}}', storeCode)
            .replace('{{callback}}', 'queryStoreCallback');

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                jsonpCallback: 'queryStoreCallback'
            }).then(data => {
                if (data.body.code === '0') {

                    resolve(data.body.data);
                } else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data));
            });
        });
    },

    /**
     * 根据门店code，查询门店活动信息
     * @params {String} storeCode 门店code
     * @return Promise
     * */
    queryStoreActByCode(storeCode) {

        let url = CONF.API.storeAct;

        url = url
            .replace('{{storeCode}}', storeCode)
            .replace('{{callback}}', 'queryStoreActCallback');

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                jsonpCallback: 'queryStoreActCallback'
            }).then(data => {
                if (data.body.code === '0') {
                    resolve(data.body.data);
                } else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data));
            });
        });
    },










    /**
     * 根据经纬度查询门店列表
     * @params {String} activityCode 活动Code
     * @params {String} cityId 城市id
     * @params {String | Number} lng
     * @params {String | Number} lat
     * @return Promise
     * */
    queryStoreByLocation(activityCode, cityId, lng, lat) {

        let url = CONF.API.locationStore;

        url = url
            .replace('{{activityCode}}', activityCode)
            .replace('{{cityId}}', cityId)
            .replace('{{lng}}', lng)
            .replace('{{lat}}', lat)
            .replace('{{callback}}', 'queryStoreCallback');

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                jsonpCallback: 'queryStoreCallback'
            }).then(data => {
                if (data.body.code === '0') {

                    resolve(data.body.data);
                } else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data));
            });
        });
    },

    // 获取活动详情
    queryActDetailsInfo(activityCode) {

        let url = CONF.API.actDetailsInfo;

        url = url
            .replace('{{activityCode}}', activityCode)
            .replace('{{callback}}', 'queryActDetailsCallback');

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {
                jsonpCallback: 'queryActDetailsCallback'
            }).then(data => {
                if (data.body.code === '0') {

                    resolve(data.body.data);
                } else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data));
            });
        });
    },
    /**


    /**
     * [查询门店列表的数据]
     * @param: {String}
     */
    queryStoreData(activityCode, cityId, lng, lat) {

        let url = CONF.API.queryStoreList;

        url = url
            .replace('{{activityCode}}', activityCode)
            .replace('{{cityId}}', cityId)
            .replace('{{lng}}', lng)
            .replace('{{lat}}', lat)
            .replace('{{callback}}', 'queryStoreDataCallback');

        return new Promise((resolve, reject) => {
            Vue.http.jsonp(url, {

                jsonpCallback: 'queryStoreDataCallback'
            }).then(data => {
                if (data.body.code === '0') {
                    resolve(data.body.data);
                } else {
                    reject(new Error(`${url}接口错误`));
                }
            }, data => {
                reject(new Error(data));
            });
        });
    }
};
export default Service;



// WEBPACK FOOTER //
// ./src/services/Index.js